import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_LP_COLLAPSED_WIDGET_TYPE_ID} from './dex-lp-collapsed-widget-type-id';
import {DexLpCollapsedWidgetComponent} from './dex-lp-collapsed-widget.component';
import {DexLpCollapsedWidgetImpl} from './dex-lp-collapsed-widget.impl';
import {DexLpCollapsedWidgetSettingsComponent} from './settings/dex-lp-collapsed-widget-settings.component';
import {DexLpCollapsedWidgetSettingsService} from './settings/dex-lp-collapsed-widget-settings.service';

export const DEX_LP_COLLAPSED_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_LP_COLLAPSED_WIDGET_TYPE_ID,
    widgetLabel:               'Liquidity Pool',
    widgetImplementationType:  DexLpCollapsedWidgetImpl,
    widgetComponentType:       DexLpCollapsedWidgetComponent,
    widgetSettingsServiceType: DexLpCollapsedWidgetSettingsService,
    settingsSchema:            [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          true,
    widgetSettingsComponentType: DexLpCollapsedWidgetSettingsComponent
};
